var opacityTargets = document.querySelectorAll('.is-opacity');
let movingTargets = document.querySelectorAll('.is-move');
let movingTargetsLtr = document.querySelectorAll('.is-move-ltr');
let willBeFancy = document.querySelectorAll('.will-be-fancy');
let willBeFancy2 = document.querySelectorAll('.will-be-fancy-2');
let willBeTyped = document.querySelectorAll('.typed');

let newTargets = [...opacityTargets, ...movingTargets, ...movingTargetsLtr];
let animatedTargets = [...willBeFancy, ...willBeFancy2];
let typingTargets = [...willBeTyped];

const options = {
    root: null,
    rootMargin: '0px 20px 0px 30px',
    threshold: [0, 0.25, 0.75, 1]
}
  
observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if(entry.intersectionRatio > 0.5) {
            entry.target.classList.add('fancy');
            observer.unobserve(entry.target)
        }
    }) 
}, options);

observer2 = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        // const boundsRect = entry.boundingClientRect;
        if(entry.intersectionRatio > 0.5) {
            // console.log(boundsRect.y)
            entry.target.classList.add('fancy-dual-box');
            observer.unobserve(entry.target)
        }
    })
}, options);


newTargets.forEach(myTarget => {
    observer.observe(myTarget)
})
animatedTargets.forEach(target => {
    observer2.observe(target)
})
